var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tx-steps"},[_c('div',{staticClass:"d-flex justify-center"},_vm._l((_vm.options.filter(function (item) { return !item.hidden; })),function(item,index){return _c('div',{key:item.step,class:[
        'text-4 font-weight-medium',
        {
          'gray--text': _vm.current !== item.step,
          clickable: item.step === 1 && item.step !== _vm.current,
          'ml-16': index > 0,
        } ],on:{"click":function($event){return _vm.setStep(item.step)}}},[_vm._v(" "+_vm._s(item.text)+" ")])}),0),_c('v-divider',{class:['my-10', 'border-' + _vm.borderType]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }